/**
@description preload的wrapper函数
*/
// import { actions } from 'modules'//所有的actions

const curry = require('curry')

function defaultPreload(preload, WrapComponent) {

  WrapComponent.preload = (args) => {
    return preload(args)
  }

  return WrapComponent
}

export default curry(defaultPreload)



// WEBPACK FOOTER //
// ./components/enhancer/preload.js